import React, { useEffect, useState, useRef } from "react";
import {
  CircularProgress,
  ButtonGroup,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Chip,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const PinDialog = ({
  openDialog,
  setOpenDialog,
  actionFunction,
  dialogTitle,
  dialogContent,
}) => {
  const [pin, setPin] = useState(null);
  useEffect(() => {
    setPin(null);
  }, [openDialog]);
  return (
    <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Typography
          variant="button"
          sx={{ color: "red", fontStyle: "italic", mb: 1.5 }}
        >
          {dialogContent}
        </Typography>
        <TextField
          label="Enter Pin"
          variant="outlined"
          type="number"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDialog(false)}>Cancel</Button>

        <Button
          onClick={() => {
            setOpenDialog(false);
            actionFunction(pin);
          }}
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default PinDialog;
